import TitleLabel from './TitleLabel'

export default TitleLabel
